<template>
    <div
        class="rounded-2xl p-4 shadow-md flex items-center justify-between bg-white border"
        :class="colorMap[color]">
        <div>
            <div class="text-sm text-gray-700">
                {{ title }}
            </div>
            <div class="text-xl font-bold text-gray-800">
                {{ $formatters.formatCurrency(amount, 0) }} VNĐ
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
  title: String,
  amount: Number,
  color: String,
  icon: String
})

const iconTag = computed(() => `hi-${props.icon}-icon`)

const colorMap = {
  green: 'border-green-100',
  red: 'border-red-100',
  blue: 'border-blue-100',
  orange: 'border-orange-100'
}

const iconBgMap = {
  green: 'bg-green-500',
  red: 'bg-red-500',
  blue: 'bg-blue-500',
  orange: 'bg-orange-500'
}
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/npm/@mdi/font/css/materialdesignicons.min.css');
</style>
